(ns app.front.view.group.admin.meeting-agenda-template-editor
  "Editor for shared meeting agenda templates at domain level"
  (:require [app.domain.committee.model :as committee-model]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.components :as uic]
            [app.front.ui.template-editor :as template-editor]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.subs :as template-subs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.string :as str-util]
            [re-frame.core-instrumented :as rf])
  (:require-macros [core.util.util :as util]))

(defn set-attr-evt [document-id attr value]
  (if (keyword? document-id)
    [::ee/set-value document-id attr value]
    [::ee/save-debounce
     nil
     :committee/edit-meeting-agenda-template
     document-id
     attr
     value
     {:notify {:success :template-editor/template-saved}}]))

(def new-document-id ::new)

(rf/reg-sub ::unsaved
  :<- [::ee/unsaved-for new-document-id]
  (fn [unsaved _]
    unsaved))

(rf/reg-event-fx ::create
  (fn [_ [_ group-id data]]
    {:comm/command {:command    :committee/create-meeting-agenda-template
                    :data       (assoc data :authority-group-id group-id)
                    :on-success [::create.success group-id]
                    :notify     {:success :template-editor/template-saved}}}))

(rf/reg-event-fx ::create.success
  (fn [_ [_ group-id status changes]]
    {:fx            [[:dispatch [::entities/apply-changes status changes]]
                     [:dispatch [::ee/cancel-changes new-document-id]]
                     [:dispatch [::template-subs/fetch-templates group-id]]]
     :route/replace {:route  :view/group.admin.template
                     :params {:template-id (entities/id-of-some-in-apply-changes :entity.type/meeting-agenda-template
                                                                                 changes)
                              :group-id    group-id}}}))

(rf/reg-event-fx ::save
  (fn [_ [_ template-id data]]
    {:comm/command {:command    :committee/save-meeting-agenda-template-content
                    :data       (assoc data :template-id template-id)
                    :on-success [::entities/apply-changes]
                    :notify     {:success :template-editor/template-saved}}}))

(rf/reg-sub ::create-disabled?
  :<- [::ee/attr-value new-document-id :meeting-agenda-template/name]
  (fn [name-value _]
    (nil? (str-util/blank->nil name-value))))

(defn create-controls [{:keys [tr group-id]}]
  (let [unsaved (<sub [::unsaved])]
    [:div.mt-4
     (cc/button {:on-click #(>evt [::create group-id unsaved])
                 :disabled (<sub [::create-disabled?])}
                (tr [:create]))]))

(defn template-form [{:keys [tr group-id template]}]
  (let [document-id (:db/id template new-document-id)
        images      (<sub [::gas/meeting-agenda-images group-id])]
    [:div
     [uic/form-field-wide
      [ui/text-input {:label-text (tr [:meeting-agenda-template/name])
                      :required   true
                      :class      "mr-2"
                      :value      (<sub [::ee/attr-value document-id :meeting-agenda-template/name])
                      :on-change  #(rf/dispatch-sync (set-attr-evt document-id
                                                                   :meeting-agenda-template/name
                                                                   (futil/tval %)))}]]

     (if (keyword? document-id)
       [create-controls (util/mmap tr group-id)]
       [:<>
        [template-editor/editor
         {:html-template (or (<sub [::ee/attr-value document-id :committee-template/agenda-pdf-html-template])
                             (:committee-template/agenda-pdf-html-template template))
          :print-css     (or (<sub [::ee/attr-value document-id :committee-template/agenda-pdf-css-template])
                             (:committee-template/agenda-pdf-css-template template))
          :tr            tr
          :on-save       #(>evt [::save
                                 document-id
                                 {:committee-template/agenda-pdf-html-template %1
                                  :committee-template/agenda-pdf-css-template  %2}])
          :title         (tr [:committee/agenda-pdf-template])
          :placeholders  committee-model/agenda-template-variables
          :images        images
          :preview-url   (file-download/download-href
                           :committee/generate-meeting-agenda-template-preview
                           {:template-id document-id})}
         [:<>
          [template-editor/editor
           {:html-template (or (<sub [::ee/attr-value document-id :committee-template/agenda-pdf-item-html-snippet])
                               (:committee-template/agenda-pdf-item-html-snippet template))
            :html-only?    true
            :small?        true
            :tr            tr
            :on-save       #(>evt [::save
                                   document-id
                                   {:committee-template/agenda-pdf-item-html-snippet %}])
            :title         (tr [:committee/agenda-item-snippet])
            :placeholders  (committee-model/agenda-item-picker-variables (<sub [::ff/enabled-flags]))
            :images        images}]
          [template-editor/editor
           {:html-template (or (<sub [::ee/attr-value document-id :committee-template/agenda-pdf-deficiency-html-snippet])
                               (:committee-template/agenda-pdf-deficiency-html-snippet template))
            :html-only?    true
            :small?        true
            :tr            tr
            :on-save       #(>evt [::save
                                   document-id
                                   {:committee-template/agenda-pdf-deficiency-html-snippet %}])
            :title         (tr [:committee/agenda-deficiency-snippet])
            :placeholders  committee-model/agenda-deficiency-template-variables
            :images        images}]]]])]))

(defn view [tr group-id template]
  [:section
   [:h2 (or (:meeting-agenda-template/name template)
            (tr [:template-editor/add-new-meeting-agenda-template]))]
   [template-form (util/mmap tr group-id template)]])
